export default {
  common_button_back: 'رجوع',
  common_button_cancel: 'إلغاء',
  common_button_next: 'تقدم',
  common_button_no: 'لا',
  common_button_ok: 'موافق',
  common_button_reset: 'إعادة ضبط',
  common_button_skip: 'تخطي',
  common_button_yes: 'نعم',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_enterEmail_email: 'يرجى إدخال عنوان بريدك الإلكتروني الخاص بالعمل',
  common_enterEmail_title: 'بريدك الإلكتروني',
  common_error_message_cameraNotAllowed: 'لاستخدام الميزة ، الرجاء السماح بالوصول إلى الكاميرا.',
  common_error_message_ForbiddenException: 'الصلاحيات غير كافية',
  common_error_message_incorrectEmail: 'يرجى ادخال عنوان بريد إلكتروني صحيح',
  common_error_message_invalidCredentials: 'عفوا! اسم المستخدم و/أو كلمة المرور غير صحيحة. الرجاء المحاولة مرة أخرى',
  common_error_message_invalidMobile: 'يرجى إدخال رقم الهاتف الجوال بالشكل الصحيح',
  common_error_message_missingField: 'خانة إجبارية',
  common_error_message_noInternetConnection: 'تم فقدان الاتصال بالإنترنت. الرجاء المحاولة مرة أخرى.',
  common_error_message_unauthorizedAccess: 'الوصول غيرمصرح به',
  common_error_message_webServiceWrongConnection: 'حدث خطأ أثناء نقل البيانات. الرجاء المحاولة مرة أخرى',
  common_error_title: 'خطأ',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_expired_title: 'Account expired',
  common_onboarding_login_button: 'Log in',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_or: 'أو',
  common_placeholder_optional: 'اختياري',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_device_footer: 'لإنشاء منصة جديدة، اتصل بموقع Proxiclick على شبكة الإنترنت',
  common_setup_device_locked_content:
    'هذه المنصة مستخدمة حاليا على جهاز آيباد آخر. في حال قمت بتفعيلها على جهاز الآيباد المتوفر لديك سيتم وقف تغعيلها على الجهاز الآخر. هل أنت متأكد من رغبتك في إنشاء هذه المنصة على هذا الجهاز؟',
  common_setup_device_locked_continue_button: 'إنشاء هذه المنصة',
  common_setup_device_locked_title: 'هذه المنصة قيد الاستخدام حاليا',
  common_setup_device_multiTenants: 'مجموعة شركات',
  common_setup_device_title: 'اختر منصتك',
  common_setup_loading_footer: 'لتغيير خصائص المنصة الخاصة بك، اتصل بموقع Proxyclick على شبكة الإنترنت',
  common_setup_loading_message: 'جاري التحضير...',
  common_setup_loading_title: 'المنصة الخاصة بك قيد الإعداد...',
  common_setup_location_footer: 'لإنشاء موقع جديد يرجى الاتصال بتطبيق Proxiclick على الإنترنت',
  common_setup_location_kiosk: 'المنصة',
  common_setup_location_kiosks: 'المنصات',
  common_setup_location_title: 'اختر موقعك',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_login_email: 'البريد الإلكتروني',
  common_setup_login_forgotPassword_button: 'هل نسيت كلمة السر؟',
  common_setup_login_password: 'كلمة السر',
  common_setup_login_title: 'تسجيل الدخول باستخدام حساب Proxyclick الخاص بك',
  common_setup_ready_header: 'هل أنت مستعد لاستخدام هذا الجهاز لإنشاء منصة لاستقبال {0} ؟',
  common_setup_ready_message: 'سيستغرق إعداد المنصة بضع دقائق ومن ثم ستكون جاهزة تماماً للاستخدام',
  common_setup_ready_setup_button: 'إعداد',
  common_setup_ready_title: 'مرحباً {0}',
  common_signup_company: 'الشركة',
  common_signup_email: 'البريد الإلكتروني',
  common_signup_error_name: 'يرجى إدخال الاسم الاول واسم العائلة',
  common_signup_loading_message1:
    'بإمكانك تعديل خصائص المنصة من خلال الاتصال بتطبيق Proxyclick على الإنترنت. لقد قمنا للتو بإرسال بريد إلكتروني بكافة التفاصيل.',
  common_signup_loading_message2:
    'بإمكانك ضبط الطابعة من الموقع الإلكتروني لطباعة البطاقة التعريفية للزائر حين تسجيل دخوله.',
  common_signup_loading_message3: 'بإمكانك أيضا تفعيل إرسال الإشعارات للزائر فور تسجيل دخوله.',
  common_signup_loading_message4: 'كما بإمكانك تعديل خصائص وألوان المنصة واختيار صورة الترحيب التي ترغب بها.',
  common_signup_loading_title: 'جاري إعداد الحساب الخاص بك ... ',
  common_signup_name: 'الاسم',
  common_signup_name_placeholder: 'الاسم الأول واسم العائلة',
  common_signup_password: 'كلمة السر',
  common_signup_title: 'أهلا بكم في Proxyclick',
  common_signup_tryFree_button: 'إرسال',
  common_timeout_content: 'المس هنا للخروج',
  common_timeout_title: 'الرجوع إلى الشاشة الرئيسية',
  common_tooltip_disable_button: 'وقف كافة الخطوات التوضيحية',
  common_tooltip_gotIt_button: 'مفهوم',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} has been informed that you delivered a package',
  dm_delivery_confirmation_title: 'شكراً!',
  dm_delivery_confirmation_unknownRecipient:
    'A notification has been sent to inform {{Company_Name}} you delivered a package for them',
  dm_delivery_recipient_name: 'Who is this package for?',
  dm_delivery_recipient_unknown_button: 'لا أعلم',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'تم تسجيل بياناتك!',
  vm_checkin_confirmation_header_withPrint: 'جار طباعة البطاقة التعربفية',
  vm_checkin_confirmation_message: 'يرجى منكم الجلوس إلى أن يحضر {{Host_FirstName}}',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'شكراً!',
  vm_checkin_details_companyName: 'الشركة',
  vm_checkin_details_email: 'البريد الإلكتروني',
  vm_checkin_details_firstname: 'الاسم الأول',
  vm_checkin_details_lastname: 'الاسم الأخير',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn: 'حدث خطأ أثناء عملية التسجيل، يرحى الاتصال بموظف الاستقبال',
  vm_checkin_flow_company: 'الشركة',
  vm_checkin_flow_duration: 'المدة',
  vm_checkin_flow_email: 'البريد الإلكتروني',
  vm_checkin_flow_error_message_imageNotAvailable: 'الصورة غير متوفرة حالياً (بشبب خلل في الاتصال بالإنترنت)',
  vm_checkin_flow_licensePlate: 'لوحة الترخيص',
  vm_checkin_flow_mobile: 'يرجى إدخال رقم هاتفك الجوال',
  vm_checkin_flow_mobile_info: 'سيتم استخدام هذه البيانات للتواصل معك في حالات الطوارئ أثناء تواجدك داخل المنشأة',
  vm_checkin_flow_tooltip_content:
    'اسأل زايريك عن أي شيء ترى بأنه قد يساهم في تحسين تجرتهم أو جعل دخولك أكثر أماناً. بإمكانك تغيير ترتيب الأسئلة اعتماداً على إجابات الزائرين. الأسئلة التي تظهر هي عبارة عن نماذج توضيحية.',
  vm_checkin_flow_tooltip_title: 'اسئلة ذكية',
  vm_checkin_host_enterFullName: 'يرجى إدخال اسم الشخص المضيف بالكامل',
  vm_checkin_host_name: 'من الشخص الذي ترغب بزيارته؟',
  vm_checkin_host_notListed_block:
    'إذا لم تكن تعرف مضيفك أو في حال لم تتمكن من إيجاده في القائمة، يرجى إعلام موظف الاستقبال',
  vm_checkin_host_notListed_continue: 'غير موجود في القائمة',
  vm_checkin_host_tooltip_content:
    'اكتب اسمك هنا وسنقوم بإرسال إشعار عن طريق البريد الإلكتروني لموظفيك عند وصول زائريهم.',
  vm_checkin_host_tooltip_title: 'إشعار بوصول الزائر',
  vm_checkin_host_unknown_button: 'لا أعلم',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'معرفة المزيد',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'موافق',
  vm_checkin_instructions_clearSignature_button: 'مسح',
  vm_checkin_instructions_sendCopy_button: 'ارسل نسخة إلى عنوان بريدي الإلكتروني',
  vm_checkin_instructions_sendCopyTo_button: 'سيتم إرسال نسخة إلى عنوان البريد الإلكتروني {0} (تغيير)',
  vm_checkin_instructions_sign: 'وقع هنا باستخدام بصمة الاصبع',
  vm_checkin_instructions_tooltip_content:
    'اطلب من زائريك الموافقة على قواعد الزيارة من خلال نقرة بسبطة أو توقيع. بإمكانك تعديل قواعد الزيارة بم ا يتناسب مع طبيعة الزائر. بإمكانك إجراء هذه التعديلات على الموقع الإلكتروني.',
  vm_checkin_instructions_tooltip_title: 'موقعة ومختومة',
  vm_checkin_method_name: 'مرحباً، ما اسمك؟',
  vm_checkin_method_name_enterFullName: 'يرجى ادخال الاسم بالكامل',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: 'غير موجود في القائمة ؟ الرجاء التأكد مع موظف الإستقبال',
  vm_checkin_method_name_notRegistered_continue: 'غير موجود في القائمة؟',
  vm_checkin_method_tooltip_content:
    'يرجى الدخول باستخدام الاسم "Justin Diaz" لمشاهدة كيف يتم التعرف على الزائرين المتكررين أو المسجلين مسبقاً.',
  vm_checkin_method_tooltip_title: 'التعرف على الزائر',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: 'التقط صورة',
  vm_checkin_picture_title: 'دعنا نأخذ صورتك!',
  vm_checkin_picture_tooltip_content:
    'بإمكانك تعديل خصائص المنصة بما يتلاءم مع احتياجاتك، كما يمكنك إضافة أو إزالة الخصائص مثل التقاط صورة للزائر أو طباعة البطاقات التعريفية.',
  vm_checkin_picture_tooltip_title: 'خصائص اختيارية',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: '؟ مرحبا، ماهو بريدك الالكتروني',
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'تسجيل الدخول',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: 'تعديل التفاصيل',
  vm_checkin_summary_groupStats: '{1} من أصل {0} متواجدون حالياً',
  vm_checkin_summary_meetingTime: 'وقت الاجتماع {0}',
  vm_checkin_summary_reviewDetails_button: 'مراجعة تفاصيل الزيارة',
  vm_checkin_summary_sendPass_button: 'إرسال تصريح مرور إلى هاتفي الجوال لاستخدامه في الزيارات المستقبلية',
  vm_checkin_summary_sendPassTo_button: 'سيتم إرسال تصريح مرور دائم إلى {0} (تغيير)',
  vm_checkin_summary_takeNewPicture_button: 'التقاط صورة جديدة',
  vm_checkin_summary_title: 'زيارتك لدى {{Company_Name}}',
  vm_checkin_summary_visiting: 'المستضيف {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'أهلاً {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',
  vm_checkin_welcome_lastVisit_today: 'Your last visit was earlier today',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_returning: 'أهلاً بعودتك {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'وداعا {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'لقد قمت بتسجيل المغادرة. نتمنى أن تكون قج استمتعت بهذه الزيارة.',
  vm_checkout_confirmation_title: 'شكراً لزيارتك!',
  vm_checkout_method_name: 'يرجى ادخال اسمك لتسجيل الدخول',
  vm_checkout_method_name_notFound: 'تعذر العثور',
  vm_checkout_method_title: 'تسجيل المغادرة',
  vm_identification_id_button: 'مرر بطاقة الهوية الوطنية ليتم مسحها',
  vm_identification_qrCode_button: 'مرر بطاقة الدعوة ليتم مسحها',
  vm_infopack_confirmation: 'شكراً! تم إرسال المعلومات إلى الرقم {0}.',
  vm_infopack_email: 'يرجى إدخال عنوان البريد الإلكتروني حتى نتمكن من إرسال المعلومات حول Proxyclick',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_send_button: 'إرسلي المعلومات',
  vm_multiTenant_title: 'أهلام بك، ما الشركة التي ترغب بزيارتها؟',
  vm_product_footer_learnMore: 'معرفة المزيد',
  vm_product_footer_noPartner: 'أنت تستخدم Proxyclick Welcome',
  vm_product_footer_partner: 'أنت تستخدم Proxy Welcome تحت رعاية {0}',
  vm_qrCode_help: 'ضع الكود بمسافة تبعد 10-15 سم من الكاميرا',
  vm_qrCode_not_recognized: 'لم يتم التعرف على الكود',
  vm_qrCode_title: 'مرر بطاقة التعريف الخاصة أو بطاقة الدخول ليتم مسحها',
  vm_signup_defaultInstruction_content:
    '<img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/>تعليمات الزيارة اتفاقية الحفاظ على السرية</h1>يسرنا >مرحباً! أن نرحب بك كضيف على شركة {{Company_Name}}</p>. كما نود التنويه إلى أن صحتك سلامتك خلال زيارتك لمنشأتنا أمر في غاية الأهمية بالنسبة لنا<p>. وبالتالي فإننا نرجو منك التقيد بالتعليمات التالية:<ul> الدخول إلى المنشأة</b>مسموح فقط إذا كان بصحبة أحد موظفي {{Company_Name}}</li>يجب وضع البطاقة <b>التعريفية </b>دائماً أثناء التواجد داخل المنشأة وتسليها إلى موظف الاستقبال عند المغادرة. في حالة حدوث أي <b>أمر طارئ</b>، على كافة االزوار مغادرة المنشأة فوراً من خلال أقرب مخرج آمن والتوجه إلى نقطة التجمع المخصصة </li><li>. يمنع على الزوار<b> التقاط الصور الفتوغرافية</b> والفيديو لأي شيء داخل المنشأة أو لأي شيء يقع في محيطها.<li><b></li> يمنع التدخين منعاً باتاً داخل المبنى</li></ul><h2>. اتفاقية الحفاظ على السرية<p></h2>. خلال زيارتك لمقر {{Company_Name}}، من المتوقع أن يتم إطلاعك على مواد (رسوم ومخططات ومواصفات ذات ملكية خاصة وذات طبيعة سرية) والتي لا تكون متاحة للجمهور بشكل عام (يشا إليها لاحقاً &#34;بالمعلومات السرية&#34;)</p><p>، وخلال زيارتك لشركة {{Company_Name}}وتواجدك في منشأتها فإنك توافق على ما يلي: </p></p> أ) عدم الإفصاح أو الشكف للآخرين عن المعلومات السرية التي تم إطلاعك عليها خلال هذه الزيارة أو أية زيارة أخرى </p><p>ب) عدم استخدام أو مساعدة الغير في استخدام أو إجراء أية شكل من أشكال العديل على المعلومات السرية </p><p>ج) عدم استخدام أجهزة التصوير الفوتوغرافي أو الفيديو بغرض الكشف عن المعلومات السرية. </p><p>بالتوقيع على هذا فإنك تقر بفهم تعليمات الصحة والسلامة وباتفاقية الحفاظ على السرية التي تم تفصيلها. </p>',
  vm_signup_defaultInstruction_name: 'يجب على كافة الزائرين الإقرار بقراءة التعليمات',
  vm_signup_defaultInstruction_title: 'يرجى القراءة الإقرار بما فيه أدناه',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'تسجيل الدخول',
  vm_welcome_checkout_button: 'تسجيل الخروج',
  vm_welcome_delivery_button: 'توصيل',
  vm_welcome_hello_line1: 'أهلا بك',
  vm_welcome_hello_line2: 'في {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'كنت هنا سابقاً ؟',
  vm_welcome_title: 'أهلاً بك في {{Company_Name}}',
  vm_welcome_tooltip_content:
    'لتغيير خصائص المنصة الخاصة بك، ادخل إلى موقع Proxyclick. لقد قمنا للتو بإرسال رسالة بريد إلكتروني بالتعليمات. يمكنك من خلال الموقع الإلكتروني تحميل الشعار الخاص بك وتعديل الخلفية واختيار اللون المناسب والذي يعكس هوية العلامة التجارية الخاصة بك على المنصة.',
  vm_welcome_tooltip_title: 'عدل المظهر بما يناسبك',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
};
